module.exports = __webpack_public_path__ + "static/c3_image-5c5532d0c953f11fb2118a7842470852.png";